import currency from './currency.js'
import percent from './percent.js'
import localeString from './localeString'

const formatters = {
  currency,
  percent,
  noop: (value) => value,
}

export default (value, { name = 'noop', hasLocaleString = false, localeStringDigits = 0, formatterArgs = {} }) => {
  let formattedValue = value
  const formatter = formatters[name]
  if (!formatter) {
    return formattedValue
  }
  if (hasLocaleString) {
    formattedValue = localeString(value, localeStringDigits)
  }
  return formatter(formattedValue, formatterArgs)
}
